import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';

import '../assets/scss/imprint.scss';

import logoRock from '../assets/img/logos/logo_fels_dunkel.svg';
import logoHydro from '../assets/img/logos/logo_hydro_dunkel.svg';
import logoGeo from '../assets/img/logos/logo_geo_dunkel.svg';
import marked from "./markdown";


class Imprint extends Component {

    render() {
        return (
            <div id={'imprint'} className={'imprint'}>

                <div className={'sections'}>
                    <div className={'icon-close close'} onClick={() => {this.props.hide()}} title={'Schließen'} />

                    <section>
                        <strong>IMPRESSUM</strong>

                        <div className={'logoBox'}>
                            <img src={logoGeo} className={'_logo'} alt={'witt & partner Geoprojekt'} width={160} height={39} />
                            <img src={logoRock} className={'_logo'} alt={'witt & partner Felsprojekt'} width={160} height={39} />
                            <img src={logoHydro} className={'_logo'} alt={'witt & partner Hydroprojekt'} width={160} height={39} />
                        </div>

                        <div dangerouslySetInnerHTML={{__html: marked(this.props.data['Links'])}} />
                    </section>

                    <section>
                        <strong>RECHTSHINWEISE / DATENSCHUTZ</strong>

                        <div dangerouslySetInnerHTML={{__html: marked(this.props.data['Rechts'])}} />

                        <div className={'disableCookie'} onClick={e => this.props.showCookieConsent()}><strong>Google Analytics de-/aktivieren</strong></div>
                    </section>
                </div>
            </div>
        );
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.show !== this.props.show) {

            let imprint = document.querySelector('#imprint');

            if (this.props.show) {
                imprint.style.maxHeight = '9999px';
            } else {
                imprint.style.maxHeight = '0';
            }

            setTimeout(() => {
                let container = imprint;

                if (!!container) {
                    let position = container.offsetTop;

                    let topBar = document.querySelector('header');
                    let topBarHeight = topBar.getBoundingClientRect();

                    window.scroll({
                        top: position - topBarHeight.height,
                        behavior: 'smooth'
                    });
                }
            }, 200);

        }

        if (prevProps.resetAll !== this.props.resetAll && !!this.props.resetAll) {
            this.props.hide()
        }
    }
}

export default withRouter(Imprint);
